import React, { useEffect, useRef } from 'react'

import { MarginProps } from 'styled-system'

import { HomePageQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import { Container, Scroller, ScrollerInner, StyledImage } from './styles'

type Props = MarginProps & {
  data: HomePageQuery
}

function SectionScroller({ data, ...rest }: Props) {
  const scrollerRef = useRef<HTMLDivElement>(null)
  const scrollerInnerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function addAnimation() {
      scrollerRef.current?.setAttribute('data-animated', 'true')
      scrollerRef.current?.setAttribute('data-animation-running', 'true')
    }

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      addAnimation()
    }
  }, [])

  useEffect(() => {
    const scrollerInnerChildren = scrollerInnerRef.current?.children

    if (!scrollerInnerChildren) return

    const scrollerContent = Array.from(scrollerInnerRef.current?.children)
    scrollerContent.forEach(item => {
      const duplicatedItem = item.cloneNode(true)
      // @ts-ignore
      duplicatedItem.setAttribute('aria-hidden', 'true')
      scrollerInnerRef.current?.appendChild(duplicatedItem)
    })
  }, [])

  useEffect(() => {
    function startAnimation() {
      scrollerRef.current?.setAttribute('data-animation-running', 'true')
    }

    function stopAnimation() {
      scrollerRef.current?.setAttribute('data-animation-running', 'false')
    }

    const scrollerElement = scrollerRef.current

    scrollerElement?.addEventListener('mouseleave', startAnimation)
    scrollerElement?.addEventListener('mouseenter', stopAnimation)

    return () => {
      scrollerElement?.removeEventListener('mouseleave', startAnimation)
      scrollerElement?.removeEventListener('mouseenter', stopAnimation)
    }
  }, [])

  if (!data.homePage?.platinumPartner) return null

  return (
    <Container {...rest}>
      <Scroller ref={scrollerRef}>
        <ScrollerInner ref={scrollerInnerRef}>
          {data.homePage.platinumPartner.map(item => (
            <StyledImage
              alt={item.logo?.alt}
              key={item.id}
              src={item.logo?.url}
            />
          ))}
        </ScrollerInner>
      </Scroller>
    </Container>
  )
}

export default SectionScroller
